import React from 'react';
import { VictoryPie, VictoryLabel } from 'victory';

const SimplePie = ({
  value,
  title,
  size,
}) => {
  const score = Math.floor(value * 100);

  let color;
  let label;
  if (score > 80) {
    color = '#89AAFD';
    label = 'High';
  } else if (score > 50) {
    color = '#f3c51f';
    label = 'Med';
  } else {
    color = '#E57373';
    label = 'Low';
  }

  return (
    <div>
      {size === 'sm' ? (
        <h6 className="m-0 text-left">
          {`${title}:`}
        </h6>
      ) : (
        <h5 className="m-0">{title}</h5>
      )}
      <svg viewBox="0 0 400 400" width="100%" height="100%">
        <VictoryPie
          standalone={false}
          colorScale={[color, '#f1f1f1']}
          data={[score, 100 - score]}
          labels={() => null}
          innerRadius={100}
        />
        <VictoryLabel
          textAnchor="middle"
          verticalAnchor="middle"
          text={label}
          x={200}
          y={200}
          style={{ fontSize: 36 }}
        />
      </svg>
    </div>
  );
};

export default SimplePie;
